module.exports = __webpack_public_path__ + "static/media/right-section.cbad366e.png";